import { z } from "@/zod";
import { ulid } from "./commonFields";

const auditLog = z.object({
  table_name: z.string(),
  operation: z.enum(["INSERT", "UPDATE", "DELETE"]),
  item_id: ulid.nullable(),
  old_data: z.record(z.string(), z.unknown()),
  new_data: z.record(z.string(), z.unknown()),
  changed_by: z.string(),
  changed_by_name: z.string(),
  changed_by_system_role_name: z.string(),
  changed_at: z.string(),
  changed_date: z.string().date(),
  id: ulid,
});

export const readAuditLog = auditLog.readonly();

export const readAuditLogTable = auditLog
  .omit({ old_data: true, new_data: true, changed_by: true })
  .readonly();
